import { render, staticRenderFns } from "./EmailTranscriptModal.vue?vue&type=template&id=39c2a4f5&"
import script from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports